export const hasSetScores = (score1, score2) => {
  const present = (score) =>
    score !== null && score !== undefined && score !== "";
  return present(score1) && present(score2);
};
